import { useEffect, useState } from 'react';
import { apiConstants, getGeneric } from '../../../common/constants';

let cachedConfig = null;
let inflight = null;
const subscribers = new Set();

const EMPTY_CONFIG = { reasons: [] };

async function fetchConfig() {
    if (cachedConfig) return cachedConfig;
    if (inflight) return inflight;
    inflight = (async () => {
        try {
            const res = await getGeneric(apiConstants.APPOINTMENT_DELIVERY_CONFIG, {});
            const obj = res?.data?.responseObj || EMPTY_CONFIG;
            cachedConfig = { reasons: Array.isArray(obj.reasons) ? obj.reasons : [] };
            return cachedConfig;
        } catch (e) {
            inflight = null;
            return EMPTY_CONFIG;
        } finally {
            inflight = null;
        }
    })();
    return inflight;
}

export function useAppointmentConfig() {
    const [config, setConfig] = useState(cachedConfig || EMPTY_CONFIG);
    const [loading, setLoading] = useState(!cachedConfig);

    useEffect(() => {
        let cancelled = false;
        if (cachedConfig) {
            setConfig(cachedConfig);
            setLoading(false);
        } else {
            fetchConfig().then((c) => {
                if (!cancelled) {
                    setConfig(c);
                    setLoading(false);
                }
            });
        }
        const handler = (c) => {
            if (!cancelled) {
                setConfig(c);
                setLoading(false);
            }
        };
        subscribers.add(handler);
        return () => {
            cancelled = true;
            subscribers.delete(handler);
        };
    }, []);

    return { config, loading };
}

export function getReasonLabel(config, code) {
    if (!code || !config?.reasons) return code || '';
    for (const group of config.reasons) {
        const found = (group.items || []).find((i) => i.code === code);
        if (found) return found.label;
    }
    return code;
}

export function getReasonCategoryLabel(config, code) {
    if (!code || !config?.reasons) return '';
    for (const group of config.reasons) {
        if ((group.items || []).some((i) => i.code === code)) return group.categoryLabel || group.category;
    }
    return '';
}
